import { FINISH_LATER_REQUEST, FINISH_LATER_SUCCESS, FINISH_LATER_FAILURE, FINISH_LATER_RESET, } from "../../actions";
const initialState = {
    data: null,
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FINISH_LATER_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, data: null });
        case FINISH_LATER_SUCCESS:
            return Object.assign(Object.assign({}, state), { data: action.payload, isLoading: false, error: null });
        case FINISH_LATER_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload, data: null });
        case FINISH_LATER_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: null, data: null });
        default:
            return state;
    }
};
export default reducer;
